import React, { useState } from "react";
import { logToSentry } from "../../config/Sentry";
import { useDispatch } from "react-redux";
import {
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    TextField,
    Typography,
    DialogActions
} from "@mui/material/";
import { strings } from "../../common/i18n";
import actions from "../../Store/actions";

/**
 * Edit Audit Group  Component
 */

export default ({ auditGroup, onCancel, type }) => {
    const isClosed = auditGroup.closedDate ? true : false;
    const [groupData, setGroupData] = useState(auditGroup);

    const handleNameChange = (name: string) => (event: Event) => {
        setGroupData({ ...groupData, [name]: event.target.value });
    };

    const handleDateChange = (name: string) => (event: Event) => {
        if (event.target.checked) {
            const currentDate = new Date().toISOString();
            setGroupData({ ...groupData, [name]: currentDate });
        } else setGroupData({ ...groupData, [name]: null });
    };
    const dispatch = useDispatch();

    const onSave = async () => {
        try {
            await dispatch(actions.auditGroups.create.patchRequest(groupData));
            dispatch(
                actions.toast.create.success(strings("updatedSuccessfully"))
            );
            onCancel();
        } catch (error) {
            const errStr = error.toString();
            logToSentry("On save audit group:", { error });
            dispatch(
                actions.toast.create.error(strings("errors.auditGroupPost"))
            );
            console.log(error);
        }
    };

    const onClose = async () => {
        try {
            const currentDate = new Date().toISOString();
            setGroupData({ ...groupData, closedDate: currentDate });
            await dispatch(
                actions.auditGroups.create.patchRequest({
                    ...groupData,
                    closedDate: currentDate
                })
            );
            dispatch(
                actions.toast.create.success(strings("updatedSuccessfully"))
            );
            onCancel();
        } catch (error) {
            const errStr = error.toString();
            Sentry.captureException(`On close audit group: ${errStr}`);
            dispatch(
                actions.toast.create.error(strings("errors.auditGroupPost"))
            );
            console.log(error);
        }
    };

    return (
        <>
            {type === "editAuditGroup" ? (
                <>
                    <Typography>
                        {strings("messages.editAuditGroup", {
                            name: auditGroup.name
                        })}
                    </Typography>
                    <FormControl fullWidth margin="normal" variant="standard">
                        <TextField
                            variant="standard"
                            label={strings("name")}
                            onChange={handleNameChange("name")}
                            value={groupData.name}
                        />
                    </FormControl>
                </>
            ) : (
                <Typography>
                    {strings("messages.groupsClose", { name: auditGroup.name })}
                </Typography>
            )}

            <DialogActions dividers>
                <Button variant="outlined" color="error" onClick={onCancel}>
                    {strings("cancel")}
                </Button>
                {type === "editAuditGroup" ? (
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={onSave}
                        disabled={groupData.name.length < 1 ? true : false}
                    >
                        {strings("save")}
                    </Button>
                ) : (
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={onClose}
                        disabled={groupData.name.length < 1 ? true : false}
                    >
                        {strings("close")}
                    </Button>
                )}
            </DialogActions>
        </>
    );
};
